// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2RtHL","header":"ClearentDisclaimer_header__gtM9i","inner":"ClearentDisclaimer_inner__qJx4V"};